import { useState } from 'react'
import { API } from '../../../../api'
import { IQDialog, Preloader } from '../../../common'
import Button from '@mui/material/Button'
import { trimAndReplaceWhiteSpaces } from '../../../../utility/string-format'
import { Stack, Typography } from '@mui/material'
import { EntitiesTypes, getEntityTitle } from '../../../../view/admin/ad-management/EntitiesTabs'

interface IProps {
  isShow: boolean
  name: string
  description: string
  oldName: string
  groups: string[]
  type: EntitiesTypes
  onSuccess: () => void
  onCancel: () => void
}
export const getRightSufix = (type: string) => {
  if (type === EntitiesTypes.omit_measures) {
    return 'omissions'
  }
  if (type === EntitiesTypes.reports) {
    return 'qlik_based_reports'
  }
  return type
}

export const EntityGroupsUpdate = ({ isShow, name, description, oldName, groups, type, onSuccess, onCancel }: IProps) => {
  const titleName = getEntityTitle(type)
  const [isLoading, setIsLoading] = useState(false)

  const handleUpdate = async () => {
    try {
      setIsLoading(true)
      await API.ADManagement.entities.update(oldName, trimAndReplaceWhiteSpaces(description), name, groups, getRightSufix(type))
      onSuccess()
    } catch (err) {
      console.log(err)
      onCancel()
    } finally {
      setIsLoading(false)
    }
  }

  const renderUpdateActions = () => (
    <Stack
      direction='row'
      spacing={2}
      justifyContent='space-between'
      sx={{
        width: '100%',
      }}
    >
      <Button
        onClick={onCancel}
        variant='outlined'
        data-testid={`${type}-update-cancel`}
      >
        Cancel
      </Button>
      <Button
        variant='contained'
        disabled={isLoading}
        onClick={handleUpdate}
        data-testid={`${type}-update-save`}
      >
        Update
      </Button>
    </Stack>
  )

  return (
    <IQDialog
      isShow={isShow}
      title={
        <Typography
          fontWeight={700}
          variant='h6'
        >
          {`Are you sure you want to update this ${titleName}?`}
        </Typography>
      }
      content={
        isLoading ? (
          <Preloader
            size='sm'
            style={{ display: 'block', margin: '0 auto' }}
          />
        ) : (
          false
        )
      }
      actions={renderUpdateActions()}
      onClose={onCancel}
      testPrefix={`${type}-update`}
    />
  )
}
